'use client';

import { createContext, useMemo } from 'react';

import { getUseStoreHookSafe } from '@/shared/utils/store';

import createHomePageStore from '../../store/form-dashboard-store';
import { FormDashboardState } from '../../types/home-store-types';

type FormDashboardContextType = {
	store: ReturnType<typeof createHomePageStore>;
};

const FormDashboardContext = createContext<FormDashboardContextType>(
	{} as FormDashboardContextType
);

export function FormDashboardProvider({
	children,
	defaultState,
}: {
	children: React.ReactNode;
	defaultState?: Partial<FormDashboardState>;
}) {
	const store = useMemo(() => createHomePageStore(defaultState), []);

	return (
		<FormDashboardContext.Provider value={{ store }}>{children}</FormDashboardContext.Provider>
	);
}

export const useFormDashboardStore = getUseStoreHookSafe<
	FormDashboardState,
	FormDashboardContextType
>(FormDashboardContext);
